import DateFnsUtils from '@date-io/date-fns';
import { yupResolver } from '@hookform/resolvers';
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents';
import { AccountFooter } from '@ifca-root/react-component/src/components/Footer/AccountFooter';
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader';
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper';
import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import { Checkbox, MenuItem, TextField } from '@material-ui/core';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import { Autocomplete } from '@material-ui/lab';
import { CommonYupValidation } from 'helpers/Form/YupValidation';
import React, { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useHistory, useLocation, useParams } from 'react-router';
import * as yup from 'yup';
import {
  useGetAssignedCompanyQuery,
  useGetCompanyNameQuery,
  useGetFaCategoryDropdownListingQuery,
  useGetCostCentreCodeLazyQuery,
  useGetFaLocationLazyQuery,
} from '@account-root/account-react/src/generated/graphql';
import NumberFormat from 'react-number-format';

interface FADetailParamsProps {
    CompanyID: string;
    AssetType: string;
    Description: string;
    AssetCardNo: string;
    CostCentreID: string;
    Year: number;
    MonthFrom: number;
    MonthTo: number;
    PurchaseDate: Date;
    ReferenceNo: string;
}

interface CompanyOption {
    Name: string;
    CompanyID: string;
}

export const FADetailParamsForm = (props: any) => {
    let history = useHistory();
    const user = JSON.parse(localStorage.getItem('loggedInUser'));
    const accountID = user.accountID;
    const { CompanyID }: any = useParams();
    let location = useLocation();
    const editData = location?.state as any;
    const latestCompany = localStorage.getItem('latestCompany');
    const ParamsSchema = yup.object().shape({
        CompanyID: CommonYupValidation.requireField('Company is required'),
        Year: yup.number()
            .integer('Year must be a whole number')
            .typeError('Year is required')
            .required('Year is required'),
        MonthFrom: yup.number()
            .integer("Month From must be a whole number")
            .lessThan(13, "Month from cannot bigger than 12")
            .moreThan(0, "Month from cannot smaller than 1")
            .typeError('Month From is required')
            .required('Month From is required'),
        MonthTo: yup.number()
            .integer("Month From must be a whole number")
            .lessThan(13, "Month from cannot bigger than 12")
            .moreThan(0, "Month from cannot smaller than 1")
            .typeError('Month To is required')
            .required('Month To is required'),
    });
    const icon = <CheckBoxOutlineBlankIcon fontSize="small"/>;
    const checkedIcon = <CheckBoxIcon fontSize="small"/>;

    const {
        handleSubmit,
        register,
        errors,
        control,
        getValues,
        watch,
        setValue,
    } = useForm<FADetailParamsProps>({
        defaultValues: {},
        mode: 'all',
        resolver: yupResolver(ParamsSchema),
    });

    const {
        loading: CompanyLoading,
        error: CompanyError,
        data: { getCompany } = { getCompany: [] },
    } = useGetCompanyNameQuery({
        variables: {CompanyID},
        fetchPolicy: 'network-only',
        onCompleted: () => {
            if(latestCompany) {
                loadCostCentre({
                    variables: {
                        CompanyID: latestCompany,
                        orderByAsc: 'Code',
                        IsLastNode: true,
                    }
                })
            }
        }
    });

    const {
        loading: CompanyAssignedLoading,
        error: CompanyAssignedError,
        data: { getAssignedCompanyByUser } = { getAssignedCompanyByUser: [] },
    } = useGetAssignedCompanyQuery({
        fetchPolicy: 'network-only',
        onCompleted: () => {
            if (latestCompany) {
                loadCostCentre({
                    variables: {
                        CompanyID: latestCompany,
                        orderByAsc: 'Code',
                        IsLastNode: true,
                    }
                })
            }
        }
    });

    const {
        loading: FACategoryDropdownListingLoading,
        error: FACategoryDropdownListingError,
        data: { getFACategoryDropdownListing } = { getFACategoryDropdownListing: [] },
    } = useGetFaCategoryDropdownListingQuery({
        fetchPolicy: 'network-only',
    });

    const [
        loadCostCentre,
        {
        loading: CostCentreLoading,
        data: { getCostCentre } = {
            getCostCentre: []
        },
        },
    ] = useGetCostCentreCodeLazyQuery({
        fetchPolicy: 'network-only',
    });

    const [selectedFACategory, setSelectedFACategory] = useState(new Set())

    const handleCheckboxFACategoryChange = (event: any) => {
        let faCatory = selectedFACategory
        event?.target?.checked ? faCatory.add(event?.target?.value) : faCatory.delete(event?.target?.value)
        setSelectedFACategory(new Set(faCatory))
    }

    const [selectedDepartment, setSelectedDepartment] = useState(new Set())

    const handleCheckboxDepartmentChange = (event: any) => {
        let department = selectedDepartment
        event?.target?.checked ? department.add(event?.target?.value) : department.delete(event?.target?.value)
        setSelectedDepartment(new Set(department))
    }

    const onSubmit = data => {
        history.push({
            pathname: '/digital-reports/fixed-assets/fixed-assets-detail-report/generated',
            state: {
                CompanyID: data?.CompanyID,
                AssetType: selectedFACategory ? Array.from(selectedFACategory) : undefined,
                AssetCardNo: data?.AssetCardNo,
                CostCentreID: selectedDepartment ? Array.from(selectedDepartment) : undefined,
                Year: data?.Year,
                MonthFrom: data.MonthFrom,
                MonthTo: data.MonthTo,
                PurchaseDate: data?.PurchaseDate ? new Date(data?.PurchaseDate) : null,
                Description: data?.Description ? data?.Description: undefined,
                ReferenceNo: data?.ReferenceNo,
            },
        })
    }

    return (
        <>
            {CompanyLoading && <Loading />}
            {CompanyAssignedLoading && <Loading />}
            {FACategoryDropdownListingLoading && <Loading />}
            {CostCentreLoading && <Loading />}

            <MainHeader
                mainBtn="back"
                onClick={() => history.push(`/digital-reports/fixed-assets`)}
                smTitle={'Fixed Assets'}
                title={user?.companyName}
                routeSegments={[
                    {name: 'Main Menu'},
                    {name: 'Submenu'},
                    {name: 'Fixed Assets Detail Report', current: true},
                ]}
                rightRouteSegments={[{name: 'Parameters', current: true}]}
            />

            <ContentWrapper float>
                <CardContents>
                    {!CompanyAssignedLoading && !CompanyLoading && (
                        <Controller
                            render={({value, onChange}) => {
                                const options: CompanyOption[] =
                                    !!user?.superUser === false
                                        ? getAssignedCompanyByUser
                                        : getCompany;
                                const defVal = getCompany?.filter(
                                    x => x?.CompanyID === latestCompany,
                                )[0];

                                return (
                                    <Autocomplete
                                        options={options || []}
                                        getOptionLabel={(option: CompanyOption) => option.Name}
                                        fullWidth
                                        onChange={(value, newValue: any) => {
                                            setValue('CompanyID', newValue?.CompanyID);

                                            loadCostCentre({
                                                variables: {
                                                    CompanyID: newValue?.CompanyID,
                                                    orderByAsc: 'Code',
                                                    IsLastNode: true,
                                                }
                                            })
                                        }}
                                        renderOption={(props, option) => {
                                            return <span>{props?.Name}</span>;
                                        }}
                                        defaultValue={defVal}
                                        renderInput={(params: any) => {
                                            return (
                                                <div>
                                                    <TextField
                                                        {...params}
                                                        helperText={errors?.CompanyID?.message}
                                                        error={errors?.CompanyID ? true : false}
                                                        label="Company"
                                                        style={{ width: '100%' }}
                                                        margin="normal"
                                                        required
                                                        defaultValue={defVal}
                                                    />
                                                </div>
                                            );
                                        }}
                                    />
                                );
                            }}
                            label="Company"
                            name="CompanyID"
                            autoComplete="off"
                            control={control}
                            multiline={true}
                            fullWidth
                            margin="normal"
                            ref={register}
                            helperText={errors?.CompanyID?.message}
                            error={errors?.CompanyID ? true : false}
                            required
                            defaultValue={latestCompany}
                        />
                    )}

                    <Controller
                        render={({ value, onChange }) => {
                            return (
                                <Autocomplete
                                    multiple
                                    disableCloseOnSelect
                                    options={getFACategoryDropdownListing || []}
                                    getOptionLabel={option => option?.name}
                                    fullWidth
                                    onChange={(value, newValue: any) => {
                                        const selecteted = new Set();

                                        newValue?.map(x => {
                                            selecteted.add(x?.fa_category_id);
                                        });

                                        setSelectedFACategory(new Set(selecteted));
                                    }}
                                    renderOption={(option, { selected }) => (
                                        <React.Fragment>
                                            <Checkbox
                                                icon={icon}
                                                checkedIcon={checkedIcon}
                                                value={option?.fa_category_id}
                                                style={{ marginRight: 8 }}
                                                checked={selected}
                                                color="primary"
                                                onChange={event => {
                                                    handleCheckboxFACategoryChange(event);
                                                }}
                                            />
                                            {option?.name}
                                        </React.Fragment>
                                    )}
                                    renderInput={(params: any) => {
                                        return (
                                            <div>
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    style={{ width: '100%' }}
                                                    label="Asset Type"
                                                    margin="normal"
                                                />
                                            </div>
                                        );
                                    }}
                                />
                            );
                        }}
                        name="AssetType"
                        label="Asset Type"
                        margin="normal"
                        autoComplete="off"
                        fullWidth
                        multiline={true}
                        control={control}
                        select
                        ref={register}
                    />

                    <Controller
                        render={({ value, onChange }) => {
                            return (
                                <Autocomplete
                                    multiple
                                    disableCloseOnSelect
                                    options={getCostCentre || []}
                                    getOptionLabel={option => option?.MasterCode}
                                    fullWidth
                                    onChange={(value, newValue: any) => {
                                        const selecteted = new Set();

                                        newValue?.map(x => {
                                            selecteted.add(x?.CostCentreID);
                                        });

                                        setSelectedDepartment(new Set(selecteted));
                                    }}
                                    renderOption={(option, { selected }) => (
                                        <React.Fragment>
                                            <Checkbox
                                                icon={icon}
                                                checkedIcon={checkedIcon}
                                                value={option?.CostCentreID}
                                                style={{ marginRight: 8 }}
                                                checked={selected}
                                                color="primary"
                                                onChange={event => {
                                                    handleCheckboxDepartmentChange(event);
                                                }}
                                            />
                                            <div>
                                                <div>
                                                    <span className="xsTitle">{option?.MasterCode}</span>
                                                </div>
                                                <div className="desc">{option?.Name}</div>
                                            </div>
                                        </React.Fragment>
                                    )}
                                    renderInput={(params: any) => {
                                        return (
                                            <div>
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    style={{ width: '100%' }}
                                                    label="Department"
                                                    margin="normal"
                                                />
                                            </div>
                                        );
                                    }}
                                />
                            );
                        }}
                        name="CostCentreID"
                        label="Department"
                        margin="normal"
                        autoComplete="off"
                        fullWidth
                        multiline={true}
                        control={control}
                        select
                        ref={register}
                    />

                    <Controller
                        as={TextField}
                        name="AssetCardNo"
                        fullWidth
                        label="Asset Card No"
                        control={control}
                        ref={register}
                    />
                    
                    <Controller
                        as={<NumberFormat allowNegative={false} />}
                        customInput={TextField}
                        id="standard-basic"
                        name="Year"
                        label="Year"
                        autoComplete="off"
                        control={control}
                        margin="normal"
                        required
                        ref={register}
                        helperText={errors?.Year ? 'Year is required' : null}
                        error={errors?.Year ? true : false}
                        defaultValue={new Date().getFullYear()}
                    />

                    <Controller
                        as={<NumberFormat allowNegative={false} />}
                        customInput={TextField}
                        id="standard-basic"
                        name="MonthFrom"
                        label="Month From"
                        autoComplete="off"
                        control={control}
                        margin="normal"
                        required
                        ref={register}
                        helperText={errors?.MonthFrom?.message}
                        error={errors?.MonthFrom ? true : false}
                        defaultValue={1}
                    />

                    <Controller
                        as={<NumberFormat allowNegative={false} />}
                        customInput={TextField}
                        id="standard-basic"
                        name="MonthTo"
                        label="Month To"
                        autoComplete="off"
                        control={control}
                        margin="normal"
                        required
                        ref={register}
                        helperText={errors?.MonthTo?.message}
                        error={errors?.MonthTo ? true : false}
                        defaultValue={1}
                    />

                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <Controller
                            as={KeyboardDatePicker}
                            name="PurchaseDate"
                            label="Purchase Date"
                            control={control}
                            onChange={(date: Date | null) => {}}
                            format="dd/MM/yyyy"
                            value={watch('PurchaseDate')}
                            margin="normal"
                            allowKeyboardControl
                            ref={register}
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                            className="dense"
                            defaultValue={editData?.PurchaseDate ?? new Date()}
                            showTodayButton
                            fullWidth
                        />
                    </MuiPickersUtilsProvider>

                    <Controller
                        as={TextField}
                        name="ReferenceNo"
                        fullWidth
                        label="Reference No"
                        control={control}
                        ref={register}
                    />
                </CardContents>
                <AccountFooter
                    options={[
                        {
                            name: 'Submit',
                            onClick: () => {
                                handleSubmit(onSubmit)();
                            },
                            color: 'primary',
                        },
                    ]}
                />
            </ContentWrapper>
        </>
    )
}

